import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  FullAsin,
  FullAsinWithAudits,
  RestrictedAsin,
} from "../../server/asin-central/model";

interface OneClickLaunchReducerState {
  // Key is asin_obf. Ex: 123456_ATVPDKIKX0DER
  indexSuppressedSelectedMap: { [key: string]: boolean };
  // Key is asin_obf. Ex: 123456_ATVPDKIKX0DER
  _3pseSelectedMap: { [key: string]: boolean };
}

export function GetOclKeyFromFullAsin(item: FullAsin) {
  return `${item.asin}_${item.obfuscatedMarketplaceId}`;
}

const initialState: OneClickLaunchReducerState = {
  indexSuppressedSelectedMap: {},
  _3pseSelectedMap: {},
};

const appSlice = createSlice({
  name: "oneClickLaunchReducer",
  initialState,
  reducers: {
    setIndexSuppressed: (
      state,
      action: PayloadAction<{ item: FullAsin; value: boolean }>
    ) => {
      const { item, value } = action.payload;
      state.indexSuppressedSelectedMap[GetOclKeyFromFullAsin(item)] = value;
    },
    setAllIndexSuppressed: (
      state,
      action: PayloadAction<{
        items: (FullAsinWithAudits | RestrictedAsin)[];
        value: boolean;
      }>
    ) => {
      state.indexSuppressedSelectedMap = action.payload.items.reduce(
        (acc: { [key: string]: boolean }, item) => {
          acc[GetOclKeyFromFullAsin(item as FullAsinWithAudits)] =
            action.payload.value;
          return acc;
        },
        {}
      );
    },
    set3pse: (
      state,
      action: PayloadAction<{ item: FullAsin; value: boolean }>
    ) => {
      const { item, value } = action.payload;
      state._3pseSelectedMap[GetOclKeyFromFullAsin(item)] = value;
    },
    setAll3pse: (
      state,
      action: PayloadAction<{
        items: (FullAsinWithAudits | RestrictedAsin)[];
        value: boolean;
      }>
    ) => {
      state._3pseSelectedMap = action.payload.items.reduce(
        (acc: { [key: string]: boolean }, item) => {
          acc[GetOclKeyFromFullAsin(item as FullAsinWithAudits)] =
            action.payload.value;
          return acc;
        },
        {}
      );
    },
    clearAllOclValues: (state) => {
      state._3pseSelectedMap = {};
      state.indexSuppressedSelectedMap = {};
    },
  },
});

export const {
  setIndexSuppressed,
  setAllIndexSuppressed,
  set3pse,
  setAll3pse,
  clearAllOclValues,
} = appSlice.actions;
export default appSlice.reducer;
